import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import BettairApp from "./BettairApp";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";


Sentry.init({
    dsn: "https://7c8eea3afcee4de8aeb0c46e6fcba796@sentry.bettair.city/3",
    integrations: [
        new Integrations.BrowserTracing(),
    ],
    tracesSampleRate: 1.0,
    environment: `${process.env.REACT_APP_ENVIRONMENT}_release`,
    release: `client-front@${process.env.REACT_APP_VERSION}`
});


ReactDOM.render(
    <BettairApp />
, document.getElementById('root')
);
